import React,{useEffect, useState} from "react";
import TextInputField  from "./../helpers/TextInputField";
import DropDownField from "./../helpers/DropDownField";
import Button from './../helpers/Button';
import { Dialog } from "primereact/dialog";
import { v4 as uuid } from "uuid"
import { getSellerSearch } from "../services/api/pettyCash";
import './index.css';
import { useDispatch } from "react-redux";
import { raiseToast } from "../services/redux/reducers/toast/toast";
import { Oval } from "react-loader-spinner";
import _ from "lodash";
import { getDateString, getProductName, getProductSpecification } from "../utils";
import { Chip } from "primereact/chip";
import Tooltip from "../helpers/Tooltip";
import Messages from "../helpers/Messages";

const SellerSearch = (props) =>{
    let { handleOnAddSeller, companyBusinessTypes, stockWarehouses, buyerReq } = props
    let {materialBrands} = props

    if(!stockWarehouses){
        stockWarehouses = []
    }

    if(!buyerReq){
        buyerReq = {orderTypeId: null}
    }

    const [selectedOption, setSelectedoption] = useState(null);
    const [searchName, setSearchName] = useState(null)
    const [sellers, setSellers] = useState([])
    const [sellerSuggestions, setSellerSuggestions] = useState([])
    const [result, setResult] = useState("Please Fill the details and Search for Sellers.")
    const [isLoading, setIsLoading] = useState(false)
    const [isSellerLoading, setIsSellerLoading] = useState(false)
    const [isAllowManualSellerEntry, setIsAllowManualSellerEntry] = useState(false)
    const [useStockMaterialIds, setUseStockMaterialIds] = useState([])

    if(!materialBrands){
        materialBrands = []
    }
    
    const dispatch = useDispatch()

    useEffect(() => {
        setIsSellerLoading(props.isSellerRecomendationsLoading)
    }, [props.isSellerRecomendationsLoading])

    useEffect(() => {
        let uniqueSellerSuggestions = _.uniqBy(props?.sellerSuggestions, "userId")
        uniqueSellerSuggestions = uniqueSellerSuggestions?.map(eachPerson => {
            let name = ""
            if (eachPerson?.firstName){
                name = eachPerson?.firstName
            }

            if (eachPerson?.lastName){
                name += " " + eachPerson?.lastName
            }
            eachPerson.name = name
            eachPerson.id = uuid()
            return eachPerson
        })

        uniqueSellerSuggestions.sort((a, b) => {
            if (a.companyId === a.pmCompanyId && b.companyId !== b.pmCompanyId) {
                return -1
            }
            if (b.companyId === b.pmCompanyId && a.companyId !== a.pmCompanyId) {
                return 1
            }
            
            return a.materialpriority - b.materialpriority
        })
        
        const relatedUniqueSellerSuggestions = uniqueSellerSuggestions.filter(eachSellerSugg => {
            const relatedStockWarehouse = stockWarehouses.find(eachStockWarehouse => eachStockWarehouse.materialId === eachSellerSugg.originalMaterialId)
            if (relatedStockWarehouse) {
                if (relatedStockWarehouse.smartStock > 0) {
                    return true
                }
                return false
            }
            return false
        })
    
        let useStockMaterialIds = []
        if(buyerReq.orderTypeId !== 3){
            useStockMaterialIds = _.uniq(relatedUniqueSellerSuggestions.map(eachSellerSugg => eachSellerSugg.originalMaterialId))
        }

        setSellerSuggestions(uniqueSellerSuggestions)
        setUseStockMaterialIds(useStockMaterialIds)
    }, [props?.sellerSuggestions])

    const selectOption=[
        {label:'Company Name', value:'companyName'},
        {label:'User Name', value:'userName'},
        {label:'Email Id', value:'emailId'},
        {label:'GSTIN', value:'gstin'}
    ]

    // console.log("sellers", sellers)
    const handleSearchClick = async (e) => {
        setIsLoading(true)
        let data 
        if (selectedOption === "companyName"){
            data = {
                companyName : searchName
            }
        } else if (selectedOption === "userName"){
            data = {
                userName : searchName
            }
        } else if (selectedOption === "emailId"){
            data = {
                emailId : searchName
            }
        }
        else if (selectedOption === "gstin"){
            data = {
                gstin : searchName
            }
        }

        data = {
            ...data,
            excludePMCompany: true,
            showSellerBranchesOnly: true
        }

        let response
        if(selectedOption && searchName){
            if (searchName.length >= 3){
                response = await getSellerSearch(data)
                // console.log("res", response)
                if (response.failure){
                    dispatch(raiseToast({severity:'error', summary: response.data.error, detail:'Seller Details has not fetched', life: 3000}))
                } else {
                    response?.map(eachPerson => {
                        eachPerson.id = uuid()
                        let name = ""
                        if (eachPerson?.firstName){
                            name = eachPerson?.firstName
                        }

                        if (eachPerson?.lastName){
                            name += " " + eachPerson?.lastName
                        }
                        eachPerson.name = name
                        // if (!eachPerson?.lastName){
                        //     eachPerson.name = eachPerson.firstName 
                        // }else{
                        //     eachPerson.name = eachPerson.firstName + " " + eachPerson.lastName  
                        // }
                        return 1
                    })
                    response?.length === 0 && setResult("No Sellers With the text you have Entered.")
                    const uniqueSellers = _.uniqBy(response, seller => JSON.stringify(_.pick(seller, ['branchId', 'userId', 'companyId'])))

                    setSellers(uniqueSellers)
                    setIsLoading(false)
                }
            }else{
                dispatch(raiseToast({severity:'error', detail:'Please Enter Atleast 3 Letters', life: 3000}))
                setIsLoading(false)
            }
        }
        else if (!selectedOption &&  !searchName) {
            dispatch(raiseToast({severity:'error', detail:'Please Select the Search Option and Enter the search text', life: 3000}))
            setIsLoading(false)
        }
        else if (!selectedOption && searchName) {
            dispatch(raiseToast({severity:'error', detail:'Please Select the Search Option', life: 3000}))
            setIsLoading(false)
        } else if (selectedOption && !searchName){
            dispatch(raiseToast({severity:'error', detail:'Please Enter the Search Text', life: 3000}))
            setIsLoading(false)
        }
    }

    const handleSellerRecommendationsOnHide = () => {
        setSellerSuggestions([])
    }

    const handleEnterKeyClick = async (e) => {
        if (e.key === "Enter"){
            setIsLoading(true)
            let data 
            if (selectedOption === "companyName"){
                data = {
                    companyName : searchName.trim()
                }
            } else if (selectedOption === "userName"){
                data = {
                    userName : searchName.trim()
                }
            } else if (selectedOption === "emailId"){
                data = {
                    emailId : searchName.trim()
                }
            } else if (selectedOption === "gstin"){
                data = {
                    gstin : searchName.trim()
                }
            }

            data.showSellerBranchesOnly = true
            data.excludePMCompany= true

            let response
            if(selectedOption && searchName){
                if (searchName.length >= 3){
                    response = await getSellerSearch(data)
                    if (response.failure){
                        dispatch(raiseToast({severity:'error', summary: response.data.error, detail:'Seller Details has not fetched', life: 3000}))
                    } else {
                        response?.map(eachPerson => {
                            eachPerson.id = uuid()
                            let name = ""
                            if (eachPerson?.firstName){
                                name = eachPerson?.firstName
                            }

                            if (eachPerson?.lastName){
                                name += " " + eachPerson?.lastName
                            }
                            eachPerson.name = name
                            // if (!eachPerson?.lastName){
                            //     eachPerson.name = eachPerson.firstName 
                            // }else{
                            //     eachPerson.name = eachPerson.firstName + " " + eachPerson.lastName  
                            // }
                            return 1
                        })
                        response?.length === 0 && setResult("No Sellers With the text you have Entered.")
                        let uniqueSellers = _.uniqBy(response, "branchId")
                        setSellers(uniqueSellers)
                        setIsLoading(false)
                    }
                }else{
                    dispatch(raiseToast({severity:'error', detail:'Please enter atleast 3 Letters', life: 3000}))
                    setIsLoading(false)
                }
            }
            else if (!selectedOption &&  !searchName) {
                dispatch(raiseToast({severity:'error', detail:'Please select the search Option and enter the search text', life: 3000}))
                setIsLoading(false)
            }
            else if (!selectedOption && searchName) {
                dispatch(raiseToast({severity:'error', detail:'Please select the search option', life: 3000}))
                setIsLoading(false)
            } else if (selectedOption && !searchName){
                dispatch(raiseToast({severity:'error', detail:'Please enter the search text', life: 3000}))
                setIsLoading(false)
            }
        }
    }

    const handleOnAddClick = (id, sellers) => {
        handleOnAddSeller(id, sellers)
    }

    const getSellerSuggestionsToolTip = (sellerTransactions) => {
        return (
            <>
                <h6 className="text-100 font-medium m-0 mb-2 text-center">These are the relevent materials procured from the seller</h6>
                <table>
                    <thead>
                        <tr className="seller-search custom-table-tr">
                            <th className="seller-search custom-th" >Branch</th>
                            <th className="seller-search custom-th" >Material Id</th>
                            <th className="seller-search custom-th" >Product Specs</th>
                            <th className="seller-search custom-th" >Date</th>
                        </tr>
                    </thead>
                    {
                        sellerTransactions.map(eachTransaction => {
                            const dateString = getDateString(eachTransaction.createdAt)
                            const relatedBrand = materialBrands.find(eachBrand => eachBrand.brandId === eachTransaction.brandId)
                            const product = `${getProductName(relatedBrand?.brandName, eachTransaction.productName, eachTransaction.variantName)} | ${getProductSpecification(eachTransaction.productSpecification)}`
                            return (
                                <tr className="seller-search custom-tr">
                                    <td className="custom-td seller-search">{eachTransaction.branchName}</td>
                                    <td className="custom-td seller-search">{eachTransaction.materialId}</td>
                                    <td className="custom-td seller-search">{product}</td>
                                    <td className="custom-td seller-search">{dateString}</td>
                                </tr>
                            )
                        })
                    }
                </table>
            </>
        )
    }

    const getMatchedRegexPattern = (text) => {
        const patterns = [
            {
                name: 'gstin',
                regex: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{3}$/
            },
            {
                name: 'emailId',
                regex: /^[a-zA-Z0-9_.±]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$/
            }
        ]
        let matchedPattern = patterns.find(pattern => pattern.regex.test(text.trim()))
    
        if (matchedPattern) {
            return matchedPattern.name
        } else {
            const textWords = text.split(' ')
            let isCompanyName = false
            textWords.forEach(eachWord => {
                const word = eachWord.toLowerCase()
                const companyKeyWords = [
                    'pvt', 'private', 'ltd', 'limited', 'enterprises', 'sales', 
                    'corp', 'corporation', 'co', 'company', 'inc', 'incorporated', 
                    'associates', 'group', 'holdings', 'ventures', 'partners', 'partnership', 
                    'consortium', 'solutions', 'technologies', 'systems', 'industries', 
                    'manufacturing', 'trading', 'services', 'innovations', 'logistics', 
                    'global', 'international', 'worldwide', 'regional', 'state', 'federal', 
                    'national', 'investments', 'capital', 'resources', 'consulting', 
                    'development', 'production', 'marketing', 'supply'
                  ]
                if (companyKeyWords.includes(word)) {
                    isCompanyName = true
                }
            })

            if (isCompanyName) {
                return 'companyName'
            }
            return 'userName'
        }
    }

    const handleSearchText = (event) => {
        setSearchName(event.target.value)
        const matchedPattern = getMatchedRegexPattern(event.target.value)
        setSelectedoption(matchedPattern)
    }

    const handleChooseManually = (event) => {
        setIsAllowManualSellerEntry((val) => !val)
    }

    return(
        <>
            <Dialog className="add-expense-dialog" header={props.header} visible={props.visible} style={{ width: '65vw',minHeight:"60%" }} onHide={props.onHide} scrollable>
                <div className=" flex flex-row" >
                    <div className="p-card" style={{ width: '65vw' }}>
                        <p className="font-bold mt-1">Recommended Sellers: </p>
                        {
                            useStockMaterialIds.length ? 
                                <Messages messages={`Material Id(s) ${useStockMaterialIds.join(', ')} available in stock. Please proceed from USE STOCK!`} sticky severity="error"/>
                            : null
                        }
                        <div className="flex flex-row flex-wrap">
                            {
                                isSellerLoading ? (
                                    <div className="flex flex-column justify-content-between align-items-center">
                                        <Oval
                                            height={45}
                                            width={45}
                                            color="#00baac"
                                            visible={true}
                                            ariaLabel='oval-loading'
                                            secondaryColor="#a4a7a6"
                                        />
                                    </div>
                                ) : (

                                    sellerSuggestions?.length === 0 ? "No Recommended Sellers are present." : (
                                        sellerSuggestions.map(eachSeller => {
                                            if (eachSeller.businessTypeId === null && eachSeller?.companyId !== 1) {
                                                eachSeller.businessTypeId = 5
                                            }
                                            if (eachSeller?.companyId === 1) {
                                                eachSeller.businessTypeId = 6
                                            }
                                            const relatedBusinessType = companyBusinessTypes?.find(eachBusinessType => eachBusinessType?.businessTypeId === eachSeller?.businessTypeId)
                                            const relatedSellers = props.sellerSuggestions.filter(eachSellerSugg => eachSellerSugg.companyId === eachSeller.companyId)
                                            const relatedMaterialIds = _.uniq(relatedSellers.map(eachRelSel => eachRelSel.originalMaterialId))

                                            let vendorBackgroundColor = ``
                                            if (eachSeller.materialpriority === 1) {
                                                vendorBackgroundColor = `#d1fcab`
                                            }
                                            else if (eachSeller.materialpriority === 2) {
                                                vendorBackgroundColor = `#fcf7b1`
                                            }
                                            else if (eachSeller.materialpriority === 3) {
                                                vendorBackgroundColor = `#cac9c9`
                                            }

                                            const tooltipStr = getSellerSuggestionsToolTip(relatedSellers)

                                            return (
                                                <div className={`p-card mr-2 custom-tooltip-${eachSeller.userId}`} style={{ maxWidth: 360, marginLeft: 2, backgroundColor: `${vendorBackgroundColor}` }} key={eachSeller.id}>
                                                    <div className="flex flex-row justify-content-between" key={eachSeller.id}>
                                                        <div><p className="m-0"> {eachSeller.name} | {eachSeller.emailId} | {eachSeller.companyName} | {eachSeller.branchName} | Score: {`${relatedBusinessType?.businessType}(${relatedBusinessType?.sourcingWeight})`} </p></div>
                                                        <div className="ml-2 align-self-center"><Button label="Add" style={{ backgroundColor: "#26a69a" }} onClick={() => handleOnAddClick(eachSeller.id, sellerSuggestions)} /></div>
                                                    </div>
                                                    <div className="flex flex-wrap mb-0 mt-2">
                                                        {
                                                            relatedMaterialIds.map(eachMaterialId => {
                                                                return(
                                                                    <div className="border-round-xs">
                                                                        <Chip label={eachMaterialId} />
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                    {eachSeller.materialpriority !== 1 &&
                                                        <Tooltip target={`.custom-tooltip-${eachSeller.userId}`} position="top" autoHide>
                                                            {tooltipStr}
                                                        </Tooltip>
                                                    }
                                                </div>
                                            )
                                        })
                                    )
                                )
                            }
                        </div>
                    </div>
                </div>
                <div className="flex justify-content-center mb-3">
                    <Button 
                        label="Enter Manually" 
                        icon={`pi ${isAllowManualSellerEntry ? 'pi-angle-double-up' : 'pi-angle-double-down'}`} 
                        onClick={handleChooseManually} 
                        text
                        tooltip={isSellerLoading ? "Loading..." : ''}
                        tooltipOptions={{ position: 'right', showOnDisabled: true }}
                    />
                </div>
                {
                    isAllowManualSellerEntry &&
                    <div style={{overflow:"hidden"}}>
                    {/* <p className="font-bold">Assign Sellers</p> */}
                    <div className="search-box">
                        <div className="p-card pb-2">
                            {
                                useStockMaterialIds.length ? 
                                    <Messages messages={`Material Id(s) ${useStockMaterialIds.join(', ')} available in stock. Please proceed from USE STOCK!`} sticky severity="error"/>
                                : null
                            }
                            <div className="flex flex-column lg:flex-row">
                                <div className="flex flex-column col-12 mb-2 lg:col-6 lg:mb-0" onKeyDownCapture={(e) => handleEnterKeyClick(e)}>
                                    <TextInputField name="" value={searchName} onChange={handleSearchText} placeholder='Please enter seller Email / GSTIN / Name / Company Name' />
                                </div>
                                <div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0">
                                    <DropDownField name="" labelText="" options={selectOption} value={selectedOption} optionValue="value" optionLabel="label" onChange={(e) => setSelectedoption(e.value)} placeholder="Search By" />
                                </div>
                                <div className="flex col-12 mb-2 lg:col-4 lg:mb-0 justify-content-end">
                                    <Button label="Search" className="small-btn" onClick={handleSearchClick} disabled={isLoading}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="seller-company-collection flex flex-column">
                        <div className="p-card">
                            {
                                isLoading ? 
                                    (
                                        <div className="flex flex-column justify-content-between align-items-center">
                                            <Oval
                                                height={45}
                                                width={45}
                                                color="#00baac"
                                                visible={true}
                                                ariaLabel='oval-loading'
                                                secondaryColor="#a4a7a6"
                                            />
                                        </div>
                                    ) : 
                                    (
                                        sellers?.length > 0 ? 
                                        (
                                            sellers.map(eachSeller => {
                                                if (eachSeller.businessTypeId === null && eachSeller?.companyId !== 1){
                                                    eachSeller.businessTypeId = 5
                                                }
                                                if (eachSeller?.companyId === 1){
                                                    eachSeller.businessTypeId = 6
                                                }
                                                const relatedBusinessType = companyBusinessTypes?.find(eachBusinessType => eachBusinessType?.businessTypeId === eachSeller?.businessTypeId )

                                                return (
                                                <div className="flex flex-row justify-content-between p-2 border-bottom-1 border-300" key={`seller-${eachSeller.id}`}>
                                                    <div> <p className="m-0"> {eachSeller.name} | {eachSeller.emailId} | {eachSeller.companyName} | {eachSeller.branchName} | Score: {`${relatedBusinessType?.businessType}(${relatedBusinessType?.sourcingWeight})`} </p></div>
                                                    <div className="ml-2"><Button label="Add" style={{backgroundColor:"#26a69a"}} onClick={() => handleOnAddClick(eachSeller.id, sellers)}/></div>
                                                </div>
                                            )})
                                        ) : (
                                            <div className="flex flex-column justify-content-between align-items-center">
                                                {result}
                                            </div>
                                        )
                                        
                                    )
                                }
                        </div>
                    </div>
                </div>}
            </Dialog>
        </>
    )
}

export default SellerSearch;